import { useCallback } from "react";
import Link from "next/link";
import * as Track from "@qoohoo/common/utils/analytics/track";
import { button, pageview } from "@qoohoo/common/constants/analytics";

const ChannelNotAvailable = ({ creatorProfileLink }) => {
  const postNotAvailableText =
    "The page you're looking for is not available now or doesn't exist.";

  return (
    <main className="mt-24 sm:mt-24 mb-28 sm:mb-56 flex flex-col items-center text-white">
      <div className="relative max-w-[256px] sm:max-w-xs text-center">
        <img
          className="mx-auto h-[148px] opacity-80"
          src="/assets/images/no-results.svg"
          alt="Content is not available"
        />
        <h3 className="mt-10 sm:text-xl leading-[150%]">
          {postNotAvailableText}
        </h3>

        <img
          src="/assets/icons/smoothcorner4.svg"
          alt="star"
          className="absolute z-[-1] h-auto w-auto -top-1 left-0 sm:-left-20 max-h-5 sm:max-h-8 block select-none"
        />
        <img
          src="/assets/icons/smoothcorner2.svg"
          alt="star"
          className="absolute z-[-1] max-h-4 sm:max-h-6 h-auto w-auto top-6 right-6 sm:right-[-64px] select-none"
        />
        <img
          src="/assets/icons/smoothcorner3.svg"
          alt="star"
          className="absolute z-[-1] max-h-5 sm:max-h-8 h-auto w-5 sm:w-8 -top-10 -right-6 sm:-right-36 select-none"
        />
      </div>

      <div className="mt-14 sm:mt-[72px]">
        <Link href={creatorProfileLink} passHref legacyBehavior>
          <button
            className="font-inter sm:text-lg font-semibold text-[#16191B] py-4 sm:py-[18px] px-12 sm:px-[88px] w-max bg-white rounded-full button-solid-shadow hover:scale-105 active:scale-100 duration-200 transition-all"
            onClick={useCallback(() => {
              Track.buttonClick(button.go_to_home, {
                url: "/",
                current_screen: pageview[404],
              });
            })}
          >
            Go To Home
          </button>
        </Link>
      </div>
    </main>
  );
};

export default ChannelNotAvailable;
